<template>
  <div class="box">
    <div class="imgs">
      <img
       src="@/assets/home.png"
       title="返回首页"
       @click="goHome"/>
      <!-- <img
       v-for="item in categoryList"
       :src="$store.state.baseUrl+'/images/'+item.categorySmallimg"
       :key="item.categoryId"
       :title="item.categoryTitle"
       :class="{active: item.categoryId == $store.state.categoryAppid}"
       @click="chooseCategory(item.categoryId)"/> -->
    </div>
    <div class="search">
      <el-input placeholder="请输入内容" prefix-icon="el-icon-search" v-model="key"
      @keyup.13.native="search"
      ></el-input>
      <el-button style="margin-left:5px" type="primary" icon="el-icon-search" @click.native="search">搜索</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions} from 'vuex'
export default {
  data() {
    return {
      categoryList: [],
      key: ''
    }
  },
  created() {
    this.findAll( { categoryType: '1' } ).then(res => {
      this.categoryList = res.data
      this.$store.commit('setCategoryList', res.data)
      // this.$store.commit('setCategory', {id: res.data[0].categoryId})
      // console.log(res.data[0].categoryId)
    })
  },
  methods: {
    ...mapActions([
      'findAll'
    ]),
    chooseCategory(id) {
      this.$store.commit('setCategory', {id: id})
      this.$router.push({path:'/layout/main/'+id})
    },
    search() {
      this.$router.push({
        path: '/layout/result/'+ this.key
      })
    },
    goHome() {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  margin: 0 auto;
  margin-top: 10px;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  .imgs {
    img {
      width: auto;
      height: 55px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
  .search {
    width: 300px;
    height: 40px;
    margin-top: 5px;
    display: flex;
    .el-input {
      border-radius: 0%;
    }
    .el-button {
      border-radius: 0%;
    }
  }
  .active {
    border: dashed 1px rgba($color: #018fd7, $alpha: 0.5);
  }
}
</style>
